.betButton {
  background-color: color-mix(in srgb, var(--cxy-color-container-default), transparent 66%);
}
.betButton[aria-pressed='true'] {
  background: var(--cxy-color-interactive-secondary);
}
.betButton[aria-pressed='true'] * {
  color: var(--cxy-color-content-dark);
}

[data-fpsm-theme='gazzetta'] .betButton div {
  span {
    font-size: 14px !important;
    font-weight: 500 !important;
  }
  span:last-child {
    font-weight: 700 !important;
  }
}
